import { Box } from "@mui/material";
import { TablaProviders } from "./TablaProviders";

export const ProviderSupplies = () => {
  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <TablaProviders />
    </Box>
  );
};
